import {signal} from "@preact/signals-react";

export const amazonPPKpisIsEmpty = signal(false);